export enum BannerKeys {
  MATCH_QUIZ = 'match-quiz',
  MATCHES_NOTIFICATION = 'matches-notification',
  REFRESH_ACTIVE_STATUS = 'refresh-active-status',
}
